import { FC, ReactNode, createContext, useContext } from 'react';

import venueRemarkStoreImpl from './venueRemarkStore';

const storeContext = createContext(venueRemarkStoreImpl);

type Props = {
  children: ReactNode;
};

export const VenueRemarkStoreProvider: FC<Props> = ({ children }) => {
  return (
    <storeContext.Provider value={venueRemarkStoreImpl}>
      {children}
    </storeContext.Provider>
  );
};

export const useVenueRemarkStore = () => useContext(storeContext);
